function Footer(props) {
  return (
    <footer>
      <div className="footer-row">
        <ul className="flex">
          {props.list.map(footerOption => (
            <li key={footerOption.index}>
              <a href="footerOption.url">{footerOption.name}</a>
            </li>
          ))} 
        </ul>
      </div>
      <p>Flixster &copy; 2024. All rights reserved</p>
    </footer>
  )
}

export default Footer;